<template>
  <article>
    <div
      :class="{
        'container mx-auto': true,
      }"
    >
      <div
        :class="{
          'grid gap-6 px-0 pt-50px text-www-color-neutral-medium-dark md:grid-cols-2 md:gap-6': true,
        }"
      >
        <div v-if="data.theChallenge?.content?.standardPortableText">
          <h3
            :class="{
              'mb-15px text-28px font-black': true,
            }"
          >
            {{ data.theChallenge.theChallengeTitle }}
          </h3>

          <PortableText :portable-data="data.theChallenge?.content?.standardPortableText" />
        </div>

        <div v-if="data.results?.content?.standardPortableText">
          <h3
            :class="{
              'mb-15px px-3 text-28px font-black': true,
            }"
          >
            {{ data.results.resultsTitle }}
          </h3>

          <PortableText :portable-data="data.results?.content?.standardPortableText" />
        </div>
      </div>
      <div
        v-if="data.pdf?.buttonText && data.pdf?.pdfFile?.asset"
        :class="{
          'flex justify-center pb-50px pt-6': true,
        }"
      >
        <Button
          :button-props="{
            _type: 'button',
            text: data.pdf.buttonText,
            style: 'primary-alt',
            link: [
              {
                _key: data.pdf.pdfFile.asset._ref,
                _type: 'pdfLink',
                pdfFile: data.pdf.pdfFile,
              },
            ],
          }"
        />
      </div>
    </div>
    <div
      :class="{
        'bg-www-color-neutral-off-white py-10 text-www-color-neutral-medium-dark': true,
      }"
    >
      <Testimonial
        v-if="data.testimonial?.reference"
        :testimonial-data="data.testimonial.reference"
        :images-to-the-right="false"
        :animated="false"
      />
    </div>

    <div
      :class="{
        'container mx-auto': true,
      }"
    >
      <PortableText
        v-if="data.content?.blogPortableText"
        :portable-data="data.content.blogPortableText"
        :class="{
          'pb-10 pt-50px text-www-color-neutral-medium-dark': true,
        }"
        :style="{
          '--wistia-max-width': videoWidthState.wistiaMaxWidth.value,
        }"
      />
    </div>
  </article>
</template>

<script lang="ts" setup>
import Button from '~/components/Atoms/Button/Button.vue';
import PortableText from '~/components/Atoms/PortableText/PortableText.vue';
import Testimonial from '~/components/Atoms/Testimonial/Testimonial.vue';
import type { QueryCaseStudyResult } from '~/sanity/types';

interface Props {
  data: NonNullable<QueryCaseStudyResult>['caseStudyContent'];
}
const videoWidthState = useVideoWidth();

defineProps<Props>();
</script>
